import React from 'react';
import { Mail, Lock, Loader2 } from 'lucide-react';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { LoginFormData, AuthError } from '../types/auth';

interface LoginFormProps {
  formData: LoginFormData;
  isLoading: boolean;
  error: AuthError | null;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => Promise<void>;
}

export const LoginForm: React.FC<LoginFormProps> = ({
  formData,
  isLoading,
  error,
  onInputChange,
  onSubmit
}) => (
  <form className="space-y-6" onSubmit={onSubmit}>
    <div>
      <label htmlFor="email" className="block text-sm font-medium text-gray-700">
        Email address
      </label>
      <div className="mt-1 relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Mail className="h-5 w-5 text-gray-400" />
        </div>
        <Input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
          className="pl-10"
          placeholder="Enter your email"
          value={formData.email}
          onChange={onInputChange}
        />
      </div>
    </div>

    <div>
      <label htmlFor="password" className="block text-sm font-medium text-gray-700">
        Password
      </label>
      <div className="mt-1 relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Lock className="h-5 w-5 text-gray-400" />
        </div>
        <Input
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          required
          className="pl-10"
          placeholder="Enter your password"
          value={formData.password}
          onChange={onInputChange}
        />
      </div>
    </div>

    <div className="flex items-center">
      <input
        id="remember-me"
        name="rememberMe"
        type="checkbox"
        className="h-4 w-4 text-[#e04530] focus:ring-[#e04530] border-gray-300 rounded"
        checked={formData.rememberMe}
        onChange={onInputChange}
      />
      <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
        Remember me
      </label>
    </div>

    {error && (
      <div className="text-sm text-red-600 bg-red-50 rounded-md p-3">
        {error.message}
      </div>
    )}

    <div>
      <Button
        type="submit"
        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#e04530] hover:bg-[#e04530]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e04530]"
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <Loader2 className="animate-spin -ml-1 mr-2 h-4 w-4" />
            Signing in...
          </>
        ) : (
          'Sign in'
        )}
      </Button>
    </div>
  </form>
); 